import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import luxuryImg from "@/assets/roofing-luxury-asphalt.jpg";
import metalImg from "@/assets/roofing-metal.jpg";
import flatImg from "@/assets/roofing-flat.jpg";
import heroImg from "@/assets/hero-roofing.jpg";

const systems = [
  { name: "Luxury Asphalt Shingles", desc: "Premium dimensional look with industry-best warranty coverage.", image: luxuryImg },
  { name: "Architectural Shingles", desc: "The most popular choice — great value, superior durability.", image: heroImg },
  { name: "Flat Roof Systems", desc: "TPO and EPDM membranes for commercial and low-slope applications.", image: flatImg },
  { name: "Standing Seam Metal", desc: "50+ year lifespan with modern aesthetics and energy savings.", image: metalImg },
];

interface Props {
  onGetPricing?: () => void;
}

export const AdsRoofingSystems = ({ onGetPricing }: Props) => (
  <section className="py-16 bg-muted/30">
    <div className="container mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground text-center mb-10">
        Premium <span className="text-primary">Roofing Systems</span>
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {systems.map(({ name, desc, image }) => (
          <div key={name} className="rounded-xl overflow-hidden border bg-card shadow-sm group">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={image} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div className="p-4">
              <h3 className="font-bold text-sm text-foreground mb-1">{name}</h3>
              <p className="text-xs text-muted-foreground mb-3 line-clamp-2">{desc}</p>
              <Button size="sm" variant="outline" className="w-full text-xs" onClick={onGetPricing}>
                Get Pricing <ArrowRight className="w-3 h-3 ml-1" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
